import Const from 'constants';
import {StackSummary as ClassicMLBStackSummary} from './mlb/classic';
import {StackSummary as ClassicLOLStackSummary} from './lol/classic';
import {StackSummary as ClassicNHLStackSummary} from './nhl/classic';

const componentMap = {
    [Const.LEAGUE_LOL]: ClassicLOLStackSummary,
    [Const.LEAGUE_MLB]: ClassicMLBStackSummary,
    [Const.LEAGUE_NHL]: ClassicNHLStackSummary,
};

export const Factory = {
    getComponent(sportConfig) {
        const sport = sportConfig.getSport().toLowerCase();

        return componentMap[sport] ?? null;
    },
};
